import { Phone, FileText, Filter, ArrowRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import type { AdsMode } from "./AdsModeSelector";

const content = {
  vente: {
    badge: "IA vocale conversationnelle",
    headline: "Une voix naturelle qui répond, écoute et qualifie chaque appel pour vous.",
    steps: [
      { icon: Phone, label: "Immovox décroche", sub: "24h/24, même en visite" },
      { icon: FileText, label: "Immovox qualifie", sub: "Projet, budget, coordonnées" },
      { icon: ArrowRight, label: "Vous rappelez", sub: "Avec la fiche sous les yeux" },
    ],
    description:
      "Votre prospect a une réponse immédiate. Vous recevez une fiche qualifiée prête à rappeler.",
  },
  location: {
    badge: "IA vocale conversationnelle",
    headline: "Une voix naturelle qui répond, écoute et collecte les infos de chaque candidat.",
    steps: [
      { icon: Phone, label: "Immovox décroche", sub: "24h/24, même le week-end" },
      { icon: Filter, label: "Immovox questionne", sub: "Solvabilité, critères, profil" },
      { icon: ArrowRight, label: "Vous priorisez", sub: "Les bons candidats d'abord" },
    ],
    description:
      "Chaque candidat reçoit une réponse immédiate. Vous recevez toutes les fiches et rappelez les meilleurs en premier.",
  },
} as const;

const AdsValueStrip = ({ mode }: { mode: AdsMode }) => {
  const { steps, description, badge, headline } = content[mode];

  return (
    <section className="py-10 bg-background">
      <div className="container mx-auto px-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={mode}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="max-w-2xl mx-auto"
          >
            <div className="text-center mb-8">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-medium text-sm mb-3">
                {badge}
              </span>
              <p className="text-lg font-semibold text-foreground max-w-xl mx-auto">
                {headline}
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4 md:gap-10 text-center mb-6">
              {steps.map((step, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.12, duration: 0.35 }}
                  className="flex flex-col items-center gap-2"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                    <step.icon className="w-6 h-6 text-primary" />
                  </div>
                  <span className="text-sm md:text-base font-bold text-foreground">
                    {step.label}
                  </span>
                  <span className="text-xs text-muted-foreground hidden sm:block">
                    {step.sub}
                  </span>
                </motion.div>
              ))}
            </div>
            <p className="text-center text-muted-foreground text-sm md:text-base">
              {description}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default AdsValueStrip;
